import { useEffect, useState } from 'react';

export const CAROUSEL_INTERVAL_MS = 7500;

// Auto-advancing carousel position. Re-arms the interval whenever the
// index changes, so a manual setCurrentIndex also restarts the clock.
const useCarouselIndex = (length, intervalMs = CAROUSEL_INTERVAL_MS) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (length < 2) { return undefined; }

    const intervalId = setInterval(() => {
      setCurrentIndex(index => (index < length - 1 ? index + 1 : 0));
    }, intervalMs);

    return () => clearInterval(intervalId);
  }, [currentIndex, length, intervalMs]);

  return [currentIndex, setCurrentIndex];
};

export default useCarouselIndex;
